const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

async function updateCartUI(openDrawer = false) {
  try {
    const sectionsToUpdate = [
      'cart-drawer',
      'cart-icon-bubble'
    ];

    const response = await fetch(`${window.Shopify.routes.cart_url}?sections=${sectionsToUpdate.join(',')}`);
    const data = await response.json();

    // Replace Cart Drawer HTML
    if (data['cart-drawer']) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(data['cart-drawer'], 'text/html');
      const newDrawer = doc.querySelector('cart-drawer') || doc.querySelector('.cart-drawer');
      const existingDrawer = document.querySelector('cart-drawer') || document.querySelector('.cart-drawer');

      if (existingDrawer && newDrawer) {
        existingDrawer.replaceWith(newDrawer);
      }
    }

    // Replace Cart Bubble HTML
    if (data['cart-icon-bubble']) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(data['cart-icon-bubble'], 'text/html');
      const newBubble = doc.querySelector('.cart-count-bubble');      
      const existingBubble = document.querySelector('.cart-count-bubble');

      if (existingBubble && newBubble) {
        existingBubble.replaceWith(newBubble);
      }
    }

    // Open drawer after update (optional)
    if (openDrawer) {
      const drawer = document.querySelector('cart-drawer');
      if (drawer) drawer.open();
    }

  } catch (err) {
    console.error("❌ Error refreshing cart:", err);
  }
}